import React from 'react'
import { MedalIcon } from '@components/MedalIcon/MedalIcon'
import { useUserRank } from '@components/TipsLeaderboard/useUserRank'
import { Box, Paragraph, Pill, Stack } from '@ui'
import { CHANNEL_INFO_PARAMS } from 'routes'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

type Props = {
    targetUserId: string
}

export const UserRankBadge = ({ targetUserId }: Props) => {
    const { rank } = useUserRank(targetUserId)

    // Only render the badge if the user has a rank and it's in the top 3
    if (typeof rank !== 'number' || rank > 3 || rank < 1) {
        return null
    }

    return (
        <Stack gap="sm">
            <Paragraph strong size="md">
                Badges
            </Paragraph>
            <UserRankPill rank={rank} />
        </Stack>
    )
}

export const UserRankPill = ({ rank }: { rank: number }) => {
    const { openPanel } = usePanelActions()

    const handleClick = () => {
        openPanel(CHANNEL_INFO_PARAMS.TIPS_LEADERBOARD)
    }

    return (
        <Pill background="level3" color="gray2" cursor="pointer" onClick={handleClick}>
            <Stack horizontal gap="xs" alignItems="center">
                <Box centerContent width="x2" height="x3">
                    <MedalIcon rank={rank} size="square_xs" />
                </Box>
                <Paragraph color="default" size="sm">
                    Top Tipper
                </Paragraph>
            </Stack>
        </Pill>
    )
}
